<template>
  <div class="calico-loan-beacon-indicator">
    <i
      v-if="activated"
      class="bi bi-currency-dollar contained-icon-medium-outlined bi-currency-dollar-active"
    />
    <i
      v-else
      class="bi bi-currency-dollar contained-icon-medium-outlined"
    />
    <label
      v-if="activated"
      class="label--large"
    >
      Funding Passport™ is <span class="active-text">active</span>
    </label>
    <label
      v-else
      class="label--large"
    >
      Funding Passport™ is not active
    </label>
    <CalicoToggle
      v-model="activated"
      :disabled="disabled"
      @update:modelValue="$emit('toggle', $event)"
    />
  </div>
</template>

<script>
import CalicoToggle from "@/components/calico/toggle/index.vue"

export default {
  name: 'CalicoLoanBeaconIndicator',
  components: {
    CalicoToggle
  },
  props: {
    value: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    }
  },
  emits: ['toggle'],
  data () {
    return {
        activated: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.activated = val
      }
    }
  }
}
</script>

<style lang="scss">
.calico-loan-beacon-indicator {
    @include inline-space($space-small);
    align-items: center;
    width: 100%;

    .bi-currency-dollar {
        background: $color-neutral;
    }

    .bi-currency-dollar-active {
        background: $color-green;
    }
    .active-text {
        color: $color-text-success;
    }
    label {
        flex: 1;
    }
}
</style>
